import styled from "styled-components";

export const FooterCopyright = styled.div`
  /* 相対パスを絶対パスに変更 */
  background: #999 url(/images/footer_bg.png) no-repeat 50%;
  height: 50px;
  width: 100%;

  bottom: 0;
  text-align: center;
  line-height: 50px;
  color: #333;

  font-size: 14px;

  a {
    color: #3366ff;
  }
`;
